import LegalAgreementsWrapper from 'features/signup/LegalAgreements/LegalAgreementsWrapper';
import React from 'react';

export default function Page() {
  return <LegalAgreementsWrapper />;
}
